/**
 * Pill-style 3-step navigation for the multi-country edit wizard.
 */

import { Flag, MessageSquare, Settings2 } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { WizardStep } from '../hooks/useMultiCountryBulkEditForm';

const STEPS: Array<{ n: WizardStep; label: string; icon: typeof Settings2 }> = [
  { n: 1, label: 'Configuration', icon: Settings2 },
  { n: 2, label: 'Countries', icon: Flag },
  { n: 3, label: 'Creative', icon: MessageSquare },
];

interface Props {
  current: WizardStep;
  onChange: (step: WizardStep) => void;
  disabled?: boolean;
}

export function StepNav({ current, onChange, disabled }: Props) {
  return (
    <nav className="flex items-center gap-1 rounded-lg border border-border/60 bg-muted/30 p-1">
      {STEPS.map((s, idx) => (
        <span key={s.n} className="flex items-center gap-1">
          {idx > 0 && <span className="px-0.5 text-muted-foreground/50">→</span>}
          <button
            type="button"
            disabled={disabled}
            onClick={() => onChange(s.n)}
            className={cn(
              'flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-colors',
              current === s.n
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
              disabled && 'pointer-events-none opacity-50',
            )}
          >
            <s.icon className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">{s.label}</span>
            <span className="sm:hidden">{s.n}</span>
          </button>
        </span>
      ))}
    </nav>
  );
}
